<!-- else loading -->
@if (isLoading) {
<mat-progress-bar
        color="primary"
        mode="indeterminate">
</mat-progress-bar>
}

@if (merged$ | async; as response) {
<div>
    @for (video of response.data ; track $index; let i = $index) {
<div class="wrapper">
        <gtw-screen-video-item (click)="openVideoDialog(video)" [video]=video></gtw-screen-video-item>
        @if (isValidUser(video.sso_id)) {
<div class="overlay">
            <mat-card>
                <div class="edit-buttons">
                    <button mat-icon-button aria-label="Update button" (click)="updateScreenVideo(video)">
                        <mat-icon>create</mat-icon>
                    </button>
                </div>
                <div class="edit-buttons">
                    <button mat-icon-button aria-label="Delete button" (click)="confirmDelete(video.video_id)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </mat-card>
        </div>
}
    </div>
}
    @if (response.callSuccess == 1 && response.data.length == 0) {
<div class="noVideos">
        No help videos.
    </div>
}
    @if (response.callSuccess == 0) {
<div>
        {{response.errorMessage}}
    </div>
}
</div>
}
